export const MOBILE_DEVICE_WIDTH = "(max-width: 800px)";

export const TOASTS_MOBILE_DEVICE_WIDTH = "(max-width: 1000px)";
